import { format } from "date-fns";
import { map } from "lodash";
import {
  CampaignWithAnswer,
  CreateCampaignData,
  EmptyProspeccaoData,
  Campaign,
  OptionChannel,
} from "../types/campaign";
import api from "./api";

export const listCampaigns = async (params: any): Promise<Campaign[]> => {
  const response = await api.get(
    "insights-p2-:stage/:stage/crm/performance/getPerformanceMes",
    { params }
  );

  return response.data.campanhas;
};

export const listDetailsCampaign = async (idCampanha: number): Promise<any> => {
  const { data } = await api.get(
    "insights-p2-:stage/:stage/crm/insights/getDesempenhoEnvio",
    { params: { idCampanha } }
  );

  const response = {
    details: data.lista[0],
    status: data.status,
  };
  return response;
};

export const listDetailsCampaignClickRate = async (
  idCampanha: number
): Promise<{ value: number; name: string }[]> => {
  const response = await api.get(
    "insights-p2-:stage/:stage/crm/getTaxaClique",
    {
      params: { idCampanha },
    }
  );

  return response.data;
};

export const listCampaignWithAnswers = async (): Promise<
  CampaignWithAnswer[]
> => {
  const response = await api.get("report-:stage/campaigns/list-with-answers");

  return response.data.content;
};

export const listTemplatesEmail = async (type: string): Promise<any> => {
  const response = await api.get("email-p1-:stage/:stage/crm/getTemplates", {
    params: { tipo_template: type },
  });
  return response.data.data;
};

export const saveEmptyProspeccao = async (data: EmptyProspeccaoData) => {
  const requestObjectData = {
    prospeccao_tipo: data.prospeccao_tipo,
    prospeccao_origem: data.prospeccao_origem,
  };

  const response = await api.post(
    "https://api.datasales.info/insights-p2-:stage/:stage/crm/prospeccao/saveEmptyProspeccao",
    requestObjectData
  );

  return response.data;
};

export const createCampaignSms = async (data: CreateCampaignData) => {
  const requestObjectData = {
    coupon: data?.coupon,
    automacaoCampanha: data?.isAutomation ? 1 : 0,
    custoCampanha: data.coastCampaign,
    dataFim: format(data?.endDate, "dd/MM/yyyy HH:mm"),
    dataFimCampanha: format(data?.endDate, "dd/MM/yyyy HH:mm"),
    dataInicio: format(data?.sendDate, "dd/MM/yyyy HH:mm"),
    dataInicioCampanha: format(data?.startDate, "dd/MM/yyyy HH:mm"),
    dia_automacao: data.whenSendAutomation?.value,
    facebook_id: data.fbPixel,
    google_tag: data.googleTag,
    hora_automacao: format(data?.intervalHour || new Date(), "HH:mm:00"),
    hostTracker: "v-ja.co/",
    idListProspectei: data.idInsight,
    mensurar_campanha: data.measureCampaign,
    message: data.message,
    nameList: data.nameInsight,
    nomeCampanha: data.name,
    numero: "",
    numerosList: data.recipientsCopy,
    origin: "Minha Base",
    pareto: "100/00",
    redirectTracker: data.redirect,
    selectedCelular: map(
      data.selectedRecipients,
      (recipient) => recipient.value
    ),
    selectedTabloide: data.digitalTabloidId,
    tipo_envio_campanha: data.campaignSendingType,
    unid_automacao: data.intervalAutomation,
    unid_tempo_automacao: data.intervalFrequency?.value,
    prospeccao_tipo: data.prospeccao_tipo,
    origem_campanha: data.origem_campanha,
  };

  const response = await api.post(
    "sms-p1-:stage/:stage/crm/postSMSLote",
    requestObjectData
  );
  return response.data;
};

export const createCampaignEmail = async (data: CreateCampaignData) => {
  const requestObjectData = {
    coupon: data?.coupon,
    automacaoCampanha: data?.isAutomation ? 1 : 0,
    custoCampanha: data.coastCampaign,
    dataFim: format(data?.endDate, "dd/MM/yyyy HH:mm"),
    dataFimCampanha: format(data?.endDate, "dd/MM/yyyy HH:mm"),
    dataInicio: format(data?.sendDate, "dd/MM/yyyy HH:mm"),
    dataInicioCampanha: format(data?.startDate, "dd/MM/yyyy HH:mm"),
    dia_automacao: data.whenSendAutomation?.value,
    email: "",
    emailList: data.recipientsCopy,
    hora_automacao: format(data?.intervalHour || new Date(), "HH:mm:00"),
    hostTracker: "v-ja.co/",
    idListProspectei: data.idInsight,
    nameList: data.nameInsight,
    nomeCampanha: data.name,
    nomeRemetente: data.nameSender,
    origin: "Minha Base",
    pareto: "100/00",
    redirectTracker: data.redirect,
    remetente: data.emailSender,
    selectedEmail: map(data.selectedRecipients, (recipient) => recipient.value),
    selectedTabloide: data.digitalTabloidId,
    subject: data.subject,
    template: data.message,
    unid_automacao: data.intervalAutomation,
    unid_tempo_automacao: data.intervalFrequency?.value,
    mensurar_campanha: data.measureCampaign,
    tipo_envio_campanha: data.campaignSendingType,
    prospeccao_tipo: data.prospeccao_tipo,
    origem_campanha: data.origem_campanha,
  };

  const response = await api.post(
    "email-p1-:stage/:stage/crm/postEmail",
    requestObjectData
  );
  return response.data;
};

export const createCampaignWhatsApp = async (data: CreateCampaignData) => {
  const isVideo = data.whatsAppUrlMidia
    ? data.whatsAppUrlMidia.endsWith(".mp4")
    : false;
  const requestObjectData = {
    dataFimCampanha: format(data?.endDate, "dd/MM/yyyy HH:mm"),
    dataInicio: format(data?.sendDate, "dd/MM/yyyy HH:mm"),
    dataInicioCampanha: format(data?.startDate, "dd/MM/yyyy HH:mm"),
    facebook_id: data.fbPixel,
    google_tag: data.googleTag,
    hostTracker: "v-ja.co/",
    idInstancia: data.whatsAppInstance?.id,
    idListProspectei: data.idInsight,
    message: data.message,
    nameList: data.nameInsight,
    nomeCampanha: data.name,
    numerosList: data.recipientsCopy,
    origin: "Minha Base",
    pareto: "100/00",
    redirectTracker: data.redirect,
    selectedCelular: map(
      data.selectedRecipients,
      (recipient) => recipient.value
    ),
    selectedTabloide: data.digitalTabloidId,
    tipo_envio_campanha: data.campaignSendingType,
    whatsapp_midia: data.whatsAppIsMidia,
    whatsapp_url: data.whatsAppUrlMidia,
    ...(isVideo ? { messageType: "VIDEO" } : {}),
    // isChild
    prospeccao_tipo: data.prospeccao_tipo,
    origem_campanha: data.origem_campanha,
  };

  const response = await api.post(
    "whatsapp-v2-:stage/campaign/create",
    requestObjectData
  );
  return response.data;
};

export const createCampaign = async (
  data: CreateCampaignData
): Promise<any> => {
  switch (data.channel) {
    case "sms":
      return createCampaignSms(data);
    case "email":
      return createCampaignEmail(data);
    case "whatsapp":
      return createCampaignWhatsApp(data);
  }
};

export const updateCampaign = async (data: any): Promise<string> => {
  const requestObjectData = {
    data_fim_campanha: format(data?.startDate, "dd/MM/yyyy HH:mm"),
    data_inicio_campanha: format(data?.endDate, "dd/MM/yyyy HH:mm"),
    id_campanha: data?.id,
    nome_campanha: data?.name,
  };
  const response = await api.post(
    "insights-p2-:stage/:stage/crm/insights/putCampanha",
    requestObjectData
  );
  return response.data.message;
};

export const counterInsightSms = async (
  idListProspectei: number,
  recipients: { value: string; label: string }[]
): Promise<{ total: number; coast: number }> => {
  const params = {
    idListProspectei,
    celular: map(recipients, (recipient) => recipient.value),
  };
  const response = await api.get(
    "sms-p1-:stage/:stage/crm/getContadorCelular",
    {
      params,
    }
  );

  const objectResponse = {
    total: response.data?.contador_celular,
    coast: Number(response.data?.valor_total),
  };

  return objectResponse;
};

export const counterInsightEmail = async (
  idListProspectei: number,
  recipients: { value: string; label: string }[]
): Promise<{ total: number; coast: number }> => {
  const params = {
    idListProspectei,
    email: map(recipients, (recipient) => recipient.value),
  };
  const response = await api.get(
    "email-p1-:stage/:stage/crm/getContadorEmail",
    {
      params,
    }
  );

  const objectResponse = {
    total: response.data?.contador_email,
    coast: Number(response.data?.valor_total),
  };

  return objectResponse;
};

export const counterCampaignInsight = async (
  idListProspectei: number,
  recipients: { value: string; label: string }[],
  channel: OptionChannel
): Promise<{ total: number; coast: number }> => {
  switch (channel) {
    case "sms":
      return counterInsightSms(idListProspectei, recipients);
    case "email":
      return counterInsightEmail(idListProspectei, recipients);
  }
};
